import { APP_URL, Routes } from './config';
import { MessageTypes } from './features/Monitor/types';

export enum OutreachTypes {
  Email = 'support/email',
  Webhooks = 'support/webhooks',
  Push = 'subscriber/push',
}

export const LoginUrls = {
  getRedirectUriForOkta: () => APP_URL + Routes.LoginCallback,
};

export const SignalApiUrls = {
  getPartnersUrl: () => `/reports/auth/introspect`,
  getMetadataUrl: () => `/reports/monitor/metadata`,
  getAllowedValuesUrl: (partnerId: string, columnName: string) =>
    `/reports/partner/${partnerId}/monitors/attribute/allowedValues/${columnName}`,
  getMonitorsUrl: (partnerId: string) =>
    `/reports/partner/${partnerId}/monitors`,
  getCsvLocationsFiles: (partnerId: string) =>
    `/reports/partner/${partnerId}/uploads/locationListCsv`,
  createCsvLocationsFile: (partnerId: string) =>
    `/reports/partner/${partnerId}/upload/locationListCsv`,
  deleteCsvLocationsFile: (partnerId: string, fileId: string) =>
    `/reports/partner/${partnerId}/upload/locationListCsv/${fileId}`,
  getIndividualMonitorUrl: (partnerId: string, monitorId: string) =>
    `/reports/partner/${partnerId}/monitor/${monitorId}`,
  createMonitorUrl: (partnerId: string) =>
    `/reports/partner/${partnerId}/monitor`,
  getOutreachMetaData: (
    partnerId: string,
    monitorId: string,
    outreachType: OutreachTypes,
  ) =>
    `/reports/partner/${partnerId}/monitor/${monitorId}/outreach/metadata/${outreachType}`,
  getSaveOutreachConfigUrl: (
    partnerId: string,
    monitorId: string,
    outreachType: OutreachTypes,
  ) => {
    return `/reports/partner/${partnerId}/monitor/${monitorId}/outreach/${outreachType}`;
  },
  getUpdateOutreachConfigUrl: (
    partnerId: string,
    monitorId: string,
    outreachId: string,
    outreachType: OutreachTypes,
  ) => {
    return `/reports/partner/${partnerId}/monitor/${monitorId}/outreach/${outreachId}/${outreachType}`;
  },

  getRetrieveOutreachConfigUrl: (
    partnerId: string,
    monitorId: string,
    outreachType: OutreachTypes,
  ) => {
    return `/reports/partner/${partnerId}/monitor/${monitorId}/outreach/${outreachType}`;
  },

  getDeleteOutreachConfigUrl: (
    partnerId: string,
    monitorId: string,
    outreachId: string,
    outreachType: OutreachTypes,
  ) => {
    return `/reports/partner/${partnerId}/monitor/${monitorId}/outreach/${outreachId}/${outreachType}`;
  },

  getEmailConfigUrl: (partnerId: string) => {
    return `/reports/partner/${partnerId}/configuration/emails`;
  },
  getEmailUpdateConfigUrl: (partnerId: string, emailId: string) => {
    return `/reports/partner/${partnerId}/configuration/emails/${emailId}`;
  },
  getCTAUrlConfigUrl: (partnerId: string, id: string = '') => {
    return `/reports/partner/${partnerId}/configuration/ctaurls/${id}`;
  },
  getCTAUrlUpdateConfigUrl: (partnerId: string, urlId: string) => {
    return `/reports/partner/${partnerId}/configuration/ctaurls/${urlId}`;
  },

  updateMonitorUrl: (partnerId: string, monitorId: string) =>
    `/reports/partner/${partnerId}/monitor/${monitorId}`,

  getSendTestMessageUrl: (
    partnerId: string,
    monitorId: string,
    outreachType: OutreachTypes,
    messageType: MessageTypes,
  ) => {
    let suffix: string = messageType;
    if (outreachType === OutreachTypes.Push && messageType === 'issue') {
      suffix = 'start';
    }
    return `/reports/partner/${partnerId}/monitor/${monitorId}/outreach/test/${outreachType}/${suffix}`;
  },

  getPostWebhooksUrl: (partnerId: string) =>
    `/reports/partner/${partnerId}/configuration/webhooks/`,
  getPatchWebhookUrl: (partnerId: string, webhookId: string) =>
    `/reports/partner/${partnerId}/configuration/webhooks/${webhookId}`,
  getTestWebhooksUrl: (partnerId: string) =>
    `/reports/partner/${partnerId}/outreach/test/configuration/webhooks`,

  getTroubleshootingWorkflows: (partnerId: string) =>
    `/reports/partner/${partnerId}/configuration/guidedTroubleshooting/workflows`,
  getPatchTroubleshootingWorkflow: (partnerId: string, workflowId: string) =>
    `/reports/partner/${partnerId}/configuration/guidedTroubleshooting/workflows/${workflowId}`,

  getDynamicFilterData: (partnerId: string) =>
    `/reports/partner/${partnerId}/monitors/dynamicFilter`,

  //API version
  getApiVersionUrl: () => `/reports/version`,

  // Autonomous Monitors
  getAutonomousMonitorsList: (partnerId: string) =>
    `/reports/partner/${partnerId}/autonomous/monitors`,

  getAutonomousMonitor: (partnerId: string, monitorId: string) =>
    `/reports/partner/${partnerId}/autonomous/monitor/${monitorId}`,

  getAutonomousMonitorEmailOutreach: (partnerId: string, monitorId: string) =>
    `/reports/partner/${partnerId}/autonomous/monitor/${monitorId}/outreach/support/email`,

  patchAutonomousMonitorEmailOutreach: (
    partnerId: string,
    monitorId: string,
    outreachId: string,
  ) =>
    `/reports/partner/${partnerId}/autonomous/monitor/${monitorId}/outreach/${outreachId}/support/email`,

  testAutonomousMonitorEmailOutreach: (partnerId: string, monitorId: string) =>
    `/reports/partner/${partnerId}/autonomous/monitor/${monitorId}/outreach/test/support/email/issue`,

  getEmailLanguages: (partnerId: string) =>
    `/reports/partner/${partnerId}/configuration/email/languages`,
};
